import { render, staticRenderFns } from "./AddEPaper.vue?vue&type=template&id=3c3ab04d&scoped=true&"
import script from "./AddEPaper.vue?vue&type=script&lang=js&"
export * from "./AddEPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3ab04d",
  null
  
)

export default component.exports